import BaseComponent from "../../baseComponent.js";
import InternalEvent from "../../../core/constants/internalEvent.js";
import DashboardService from "../../../core/services/dashboardService.js";
import WidgetService from "../../../core/services/widgetService.js";
import UniqueIdGenerator from "../../../core/utils/uniqueIdGenerator.js";
import WidgetType from "../../../core/constants/widgetType.js";
import { variableTypes } from "./selection-contorl/constants";

import styles from "./styles.scss";

export class AddDatasetControlWidget extends BaseComponent {
  constructor(props) {
    super(props);
    this.dashboardState = [];
    this.state = this.getInitialState();
  }

  componentDidMount() {
    this.$modal = $("#add-dataset-control-widget");
    this.$modal.modal({
      dismissible: false
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.editControlWidget) {
      const metaData = nextProps.editControlWidget.metaData;
      this.setState({
        title: metaData.title,
        variableName: metaData.variableName,
        editMode: true,
        visibleExp: metaData.visible ? metaData.visible.expression : ""
      });
    }
  }

  getInitialState() {
    return {
      title: "",
      error: "",
      editMode: false,
      variableName: "",
      variables: [],
      visibleExp: ""
    };
  }

  addOrUpdate() {
    const error = this.validate();
    if (error) {
      this.setState({
        error: error
      });
      return;
    }

    const variables = this.getVariables();
    const metaData = {
      type: "dataset",
      title: this.state.title,
      variableName: this.state.variableName,
      variables,
      visible: {
        type: variableTypes.EXPRESSION,
        expression: this.state.visibleExp
      }
    };

    if (this.state.editMode) {
      const widget = this.checkDuplicatedControlWidget(this.state.variableName);
      if (widget && widget.id !== this.props.editControlWidget.id) {
        this.setState({
          error: "Variable name already in use"
        });
      } else {
        this.addOrUpdateDashboardVariable(variables)
          .then(() => {
            const widgetId = this.props.editControlWidget.id;
            WidgetService.updateWidgetMetaData(widgetId, metaData);
            this.publish(InternalEvent.Dashboard.DASHBOARD_VARIABLE_CHANGED, variables);
            this.publish(InternalEvent.Dashboard.CONTROL_UPDATED, {widgetId});
            this.hide();
          });
      }
    } else {
      this.addOrUpdateDashboardVariable(variables)
        .then(() => {
          this.publish(InternalEvent.Dashboard.CONTROL_ADDED, metaData);
          this.hide();
        });
    }
  }

  // Dataset widget creates three dashboard variables
  // [variableName]SearchText, [variableName]DatasetId, [variableName]DatasetName
  getVariables() {
    const searchTextVariable = this.getVariableByType("SearchText");
    const datasetIdVariable = this.getVariableByType("DatasetId");
    const datasetNameVariable = this.getVariableByType("DatasetName");

    return [
      {
        id: searchTextVariable ? searchTextVariable.id : UniqueIdGenerator.id(),
        name: this.state.variableName + "SearchText",
        value: searchTextVariable ? searchTextVariable.value : ""
      },
      {
        id: datasetIdVariable ? datasetIdVariable.id : UniqueIdGenerator.id(),
        name: this.state.variableName + "DatasetId",
        value: datasetIdVariable ? datasetIdVariable.value : ""
      },
      {
        id: datasetNameVariable ? datasetNameVariable.id : UniqueIdGenerator.id(),
        name: this.state.variableName + "DatasetName",
        value: datasetNameVariable ? datasetNameVariable.value : ""
      }
    ]
  }

  getVariableByType(type) {
    for (let variableId in this.state.variables) {
      const name = this.state.variables[variableId].name || "";
      if (name === this.state.variableName + type) {
        return this.state.variables[variableId];
      }
    }
    return null;
  }

  addOrUpdateDashboardVariable(variables) {
    const toUpdate = {};
    variables.forEach(v => toUpdate[v.id] = v);
    return DashboardService.updateDashboardVariables(toUpdate)
  }

  validate() {
    let error = null;
    if (this.state.variableName.trim().length === 0) {
      error = "Type a variable name";
    }
    return error;
  }

  show() {
    DashboardService.getCurrentDashboard()
      .then(dashboard => {
        this.dashboardState = dashboard.state.dashboardState;
        this.setState({
          variables: dashboard.variables
        });
        this.$modal.modal("open");
        Materialize.updateTextFields();
      });
  }

  checkDuplicatedControlWidget(variableName) {
    const widgetModels = this.dashboardState.map(s => s.widgetModel);
    const widget = widgetModels.find(widget =>
      widget.type === WidgetType.CONTROL_WIDGET && widget.metaData.variableName === variableName);
    return widget;
  }

  hide() {
    this.$modal.modal("close");
    this.setState(this.getInitialState());
  }

  handleChange(value) {
    const newState = this.copyState();
    newState.error = "";
    newState.variableName = value;
    this.setState(newState);
  }

  render() {
    let error;
    if (this.state.error) {
      error = <div className={styles.error}>{this.state.error}</div>
    }

    return (
      <div className={["modal", styles.modalContainer].join(" ")} id="add-dataset-control-widget" ref="container">
        <div className="modal-content" style={{height: 'initial'}}>
          <h4
            className={styles.title}>{this.state.editMode ? "Edit Dataset Control Widget" : "Add Dataset Control Widget"}</h4>
          {error}
          <div className="row">
            <div className="input-field col s12" style={{width: "300px"}}>
              <input id="widget-title" type="text"
                     value={this.state.title}
                     onChange={e => this.setState({title: e.target.value})}/>
              <label htmlFor="widget-title">Widget Title</label>
            </div>
            <div className="input-field col s12">
              <input type="text" value={this.state.variableName} name="variableName"
                     onChange={e => this.handleChange(e.target.value)}/>
              <label htmlFor="variableName">Variable Name</label>
            </div>
            <div className="input-field col s12">
              <input type="text" value={this.state.visibleExp} name="visibleExp"
                onChange={e => this.setState({ visibleExp: e.target.value })} />
              <label htmlFor="visibleExp">Visibility</label>
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <a className="waves-effect waves-light btn-flat"
             onClick={this.addOrUpdate}>{this.state.editMode ? "Update" : "Add"}</a>
          <a className="waves-effect btn-flat" onClick={this.hide}>Cancel</a>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/control-widget/add-dataset-control.jsx